import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import {
  SysConnessioneDati,
  Environment,
  ISysConnessioneDatiModel,
  IsErrorValues,
  IsError,
  Allegati,
} from '../../models/-index';

import { Observable } from 'rxjs';

@Injectable()
export class SysConnessioneDatiService extends CrudGenericsService<SysConnessioneDati, string> {
  private base: string;
  private out_env: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/SysConnessioneDati`);
    this.base = `${env.apiUrl}/api/SysConnessioneDati/`;
    this.out_env = env.apiUrl;
  }

  // ************* sezione: SysConnessioneDati ***********
  // Token per connessione dati
  ConnessioneDati_SendToken(idutente: string, giorni: number): Observable<IsErrorValues> {
    const u = this.base + 'ConnessioneDati_SendToken?id=' + idutente + '&giorni=' + giorni;
    return this.http.get<IsErrorValues>(`${u}`);
  }
  ConnessioneDati_GetAll(): Observable<ISysConnessioneDatiModel[]> {
    const u = this.base + 'ConnessioneDati_GetAll';
    return this.http.get<ISysConnessioneDatiModel[]>(`${u}`);
  }
  // per test cambiare il ruolo !
  OutTest_GetDatiProcedureAndCheckLists(): Observable<any[]> {
    const u = this.out_env + 'out/SysConnessioneDati/OutTest_GetDatiProcedureAndCheckLists';
    return this.http.get<any[]>(`${u}`);
  }
  // *****************************************************
  // dashboard

  DashboardSetAllegati(model: SysConnessioneDati): Observable<IsError> {
    const u = this.base + 'DashboardSetAllegati';
    return this.http.post<IsError>(`${u}`, model);
  }
  DashboardGetAllegati(caller: string): Observable<Allegati[]> {
    const u = this.base + 'DashboardGetAllegati?caller=' + caller;
    return this.http.get<Allegati[]>(`${u}`);
  }
}
